import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import moment from "moment";
import columns from "../../columns/clients/importClient";
import Send from "../../assets/Send";
import { GetImportedClientApi } from "../../api/request/clients/clients";
import { ForgotPasswordLinkApi } from "../../api/request/auth";
import Spinner from "../../components/loader/Spinner";
import SkeletonTable from "../../components/table/SkeletonTable";

const ImportClient = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const getClientList = async (page = 1) => {
    try {
      setIsLoading(true);
      const { data } = await GetImportedClientApi({ page });
      if (data.status) {
        const clientData = data?.data?.map((item) => {
          return {
            ...item,
            statusText: (
              <p
                className={`font-bold uppercase ${
                  item?.status === "sent" ? "text-green-500" : "text-red-500"
                }`}
              >
                {item?.status}
              </p>
            ),
            created_at: item?.created_at
              ? moment(item?.created_at).format("LL")
              : "",
            action: (
              <button onClick={() => sendMail(item)}>
                <Send />
              </button>
            ),
          };
        });
        setData(clientData);
        setTotal(data?.total_record);
        setCurrentPage(page);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
    }
  };

  const setClientList = (client, loading, status) => {
    setData((prev) => {
      return prev.map((item) => {
        if (item?.id === client?.id) {
          return {
            ...item,
            status,
            statusText: (
              <p
                className={`font-bold uppercase ${
                  status === "sent" ? "text-green-500" : "text-red-500"
                }`}
              >
                {status}
              </p>
            ),
            action: loading ? (
              <Spinner />
            ) : (
              <button onClick={() => sendMail(item)}>
                <Send />
              </button>
            ),
          };
        }
        return item;
      });
    });
  };

  useEffect(() => {
    getClientList();
  }, []);

  const handleTableChange = (pagination) => {
    getClientList(pagination?.current);
  };

  const sendMail = async (client) => {
    if (!client?.email) return;
    try {
      setClientList(client, true, "pending");
      const { data } = await ForgotPasswordLinkApi({ email: client?.email });
      if (data?.status) {
        toast.success(data?.message);
        setClientList(client, false, "sent");
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setClientList(client, false, client?.status);
    }
  };

  return (
    <div>
      <div className="border rounded-lg bg-White pb-5">
        <div className="flex items-center justify-between p-5">
          <p className="font-semibold text-xl">
            Imported Clients {total ? `(${total})` : null}
          </p>

          {/* <div className="flex gap-5">
            <button className="bg-secondary text-White flex items-center gap-2 rounded-lg py-2 px-4">
              <Add />
              <span>Import Client</span>
            </button>
          </div> */}
        </div>

        <SkeletonTable
          columns={columns}
          data={data}
          isLoading={isLoading}
          searchingFields={["first_name", "email", "mobile"]}
          pagination={{
            current: currentPage,
            total: total,
            pageSize: 10,
            showSizeChanger: false,
          }}
          handleTableChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default ImportClient;
